import createTheme from '@mui/material/styles/createTheme'
import responsiveFontSizes from '@mui/material/styles/responsiveFontSizes'

let Theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6b1bab',
      contrastText: '#ffffff',
      light: '#f1e0ff',
    },
    secondary: {
      main: '#ffb403',
      contrastText: '#ffffff',
    },
    info: {
      main: '#371d6e',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    button: {
      fontWeight: 500,
      textTransform: 'none',
      fontSize: '1em',
    },
  },
  shadows: [
    'none',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
    'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
    'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
    'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
    'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
    'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
    'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
    'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
    'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
  ],
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
  },
})

Theme = responsiveFontSizes(Theme)

export default Theme
